<div *ngIf="!isCustomer && !inProgress">
  <div class="row">
    <div class="col-12">
      <h1>{{ translate.currentLang === 'en' ? 'Admin Dashboard' : 'অ্যাডমিন ড্যাশবোর্ড' }}</h1>
    </div>
  </div>
</div>

<div *ngIf="isCustomer">
  <!-- First Row: Total Net worth, Asset Allocation -->
  <div class="row mb-2 align-items-stretch g-2">
    <!-- Total Net worth Card -->
    <div class="col-12 col-md">
      <div class="dashboard-card net-worth-card">
        <h3>{{ translate.currentLang === 'en' ? 'Total Net worth' : 'মোট নেট মূল্য' }}</h3>
        <p class="subtitle">{{ translate.currentLang === 'en' ? 'Here\'s how your investments are performing today...' :
          'আজ আপনার বিনিয়োগ কীভাবে পারফর্ম করছে তা এখানে রয়েছে।' }}</p>
        <div class="card-loader" *ngIf="balanceInProgress">
          <div class="spinner"></div>
        </div>
        <div class="net-worth-value">
          <span class="currency">৳</span>
          <span class="amount">{{ getTotalNetWorth() | number : 2 : true }}</span>
        </div>
      </div>
    </div>

    <!-- Asset Allocation Card -->
    <div class="col-12 col-md" *ngIf="hasAnyProductValue()">
      <div class="dashboard-card asset-allocation-card">
        <h3>{{ translate.currentLang === 'en' ? 'Asset Allocation' : 'অ্যাসেট বরাদ্দ' }}</h3>
        <div class="card-loader" *ngIf="balanceInProgress">
          <div class="spinner"></div>
        </div>
        <div class="allocation-item" *ngFor="let item of getSortedAllocationItems()">
          <div class="allocation-header">
            <span>{{ translate.currentLang === 'en' ? item.nameEn : item.nameBn }}</span>
            <span class="percentage">{{ getAllocationLabel(item.product) }}</span>
          </div>
          <div class="progress-bar">
            <div class="progress-fill" [style.width.%]="getAllocationPercentage(item.product)"
              [style.background-color]="item.color">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row g-2">
    <!-- Product Details -->
    <div class="col-12">
      <!-- Second Row: 3 columns -->
      <div class="row mb-2 align-items-stretch g-2">


        <!-- Equities Details Card -->
        <div class="col-12 col-md-6 col-lg">
          <div class="dashboard-card product-details-card">
            <div class="card-header">
              <div class="card-header-left">
                <i class="fas fa-chart-line product-logo"></i>
                <h4>{{ translate.currentLang === 'en' ? 'Equities' : 'ইকুইটি' }}</h4>
              </div>
              <div class="card-header-right">
                <span class="badge badge-cals" *ngIf="hasBalance('CALS')">{{ getAllocationLabel('CALS') }}</span>
              </div>
            </div>
            <div class="card-loader" *ngIf="balanceInProgress">
              <div class="spinner"></div>
            </div>
            <p class="balance-error" role="status" *ngIf="!balanceInProgress && balanceErrors.CALS">
              {{ translate.currentLang === 'en' ? "We couldn't load this balance. Refresh the page to try again." : 'ব্যালেন্স লোড করা যায়নি। আবার চেষ্টা করতে পেজটি রিফ্রেশ করুন।' }}
            </p>
            <div *ngIf="calsBalancesDetails?.length">
              <app-card-balance [hidden]="balanceInProgress" division="CALS"
                [accountFinBalances]="(accountFinBalances && accountFinBalances.length > 0 && accountFinBalances[0]) || null"
                [calsBalances]="calsBalancesDetails" [calsTotal]="totalBalanceOnCALS">
              </app-card-balance>
            </div>

            <!-- An existing equity account is the live product. A portal signup left in Draft is not its status. -->
            <ng-container *ngIf="hasSignedUp('CALS'); else statusButton">
              <button class="view-portfolio-btn" (click)="navigateProduct('CALS')">
                {{ getButtonText('CALS') }}
              </button>
            </ng-container>
            <ng-template #statusButton>
              <ng-container
                *ngTemplateOutlet="statusTemplate; context: { status: getProductStatus('CALS'), prdType: 'CALS', link: '/products/equity' }"></ng-container>
            </ng-template>
          </div>
        </div>

        <!-- Margin Trading Details Card -->
        <div class="col-12 col-md-6 col-lg" *ngIf="currentUser?.marginTradeDetails?.length > 0">
          <div class="dashboard-card product-details-card">
            <div class="card-header">
              <div class="card-header-left">
                <i class="fas fa-chart-bar product-logo"></i>
                <h4>{{ translate.currentLang === 'en' ? 'Margin Trading' : 'মার্জিন ট্রেডিং' }}</h4>
              </div>
              <div class="card-header-right">
                <span class="badge badge-ledger" *ngIf="hasBalance('LEDGER')">{{ getAllocationLabel('LEDGER') }}</span>
              </div>
            </div>
            <div class="card-loader" *ngIf="balanceInProgress">
              <div class="spinner"></div>
            </div>
            <p class="balance-error" role="status" *ngIf="!balanceInProgress && balanceErrors.LEDGER">
              {{ translate.currentLang === 'en' ? "We couldn't load this balance. Refresh the page to try again." : 'ব্যালেন্স লোড করা যায়নি। আবার চেষ্টা করতে পেজটি রিফ্রেশ করুন।' }}
            </p>
            <div *ngIf="currentUser?.marginTradeDetails?.length">
              <app-card-balance [hidden]="balanceInProgress" division="LEDGER"
                [ledgerTotal]="totalBalanceOnLEDGER"> </app-card-balance>
            </div>

            <button class="view-portfolio-btn" (click)="navigateProduct('LEDGER')">{{ getButtonText('LEDGER')
              }}</button>
          </div>
        </div>

        <!-- Fixed Income Details Card -->
        <div class="col-12 col-md-6 col-lg">
          <div class="dashboard-card product-details-card">
            <div class="card-header">
              <div class="card-header-left">
                <i class="fas fa-coins product-logo"></i>
                <h4>{{ translate.currentLang === 'en' ? 'Fixed Income' : 'ফিক্সড ইনকাম' }}</h4>
              </div>
              <div class="card-header-right">
                <span class="badge badge-cali" *ngIf="hasBalance('CALI')">{{ getAllocationLabel('CALI') }}</span>
              </div>
            </div>
            <div class="card-loader" *ngIf="balanceInProgress">
              <div class="spinner"></div>
            </div>
            <p class="balance-error" role="status" *ngIf="!balanceInProgress && balanceErrors.CALI">
              {{ translate.currentLang === 'en' ? "We couldn't load this balance. Refresh the page to try again." : 'ব্যালেন্স লোড করা যায়নি। আবার চেষ্টা করতে পেজটি রিফ্রেশ করুন।' }}
            </p>
            <div *ngIf="caliBalancesDetails?.length">
              <app-card-balance [hidden]="balanceInProgress" division="CALI" [caliTotal]="totalBalanceOnCALI"
                [caliBalances]="caliBalancesDetails"> </app-card-balance>
            </div>
            <!-- <div class="signed-acc-types-container" *ngIf="hasSignedUp('CALI')">
              <span class="signed-acc-types">
                <i class="ind fas fa-user-tie" *ngIf="hasAccountType('CALI', 'individual')"></i>
                <i class="joint fas fa-handshake" *ngIf="hasAccountType('CALI', 'joint')"></i>
                <i class="corp fas fa-building" *ngIf="hasAccountType('CALI', 'corporate')"></i>
              </span>
            </div> -->
            <ng-container
              *ngTemplateOutlet="statusTemplate; context: { status: getProductStatus('CALI'), prdType: 'CALI', link: '/products/fixed-income' }"></ng-container>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- Row: VSTOCK and Connect side by side -->
  <div class="row align-items-stretch g-2">
    <div class="col-12 col-lg-8">
      <div class="dashboard-card vstock-card product-ads-card" (mouseenter)="pauseVstockAutoRotate()"
        (mouseleave)="resumeVstockAutoRotate()" (focusin)="pauseVstockAutoRotate()" (focusout)="resumeVstockAutoRotate()">
        <div class="vstock-slides-container product-ads-slides-container">
          <div class="vstock-content product-ads-content"
            [class.active]="currentVstockSlideIndex >= 0 && vstockSlides.length > 0"
            [attr.data-slide]="currentVstockSlideIndex"
            [style.background-image]="currentVstockSlide?.image ? 'url(' + currentVstockSlide.image + ')' : null">
            <div class="vstock-header">
              <div class="vstock-logo">
                <span class="vstock-logo-bg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                    <path d="M16 7h6v6" />
                    <path d="m22 7-8.5 8.5-5-5L2 17" />
                  </svg>
                </span>
                <span class="vstock-title">VSTOCK</span>
              </div>
            </div>
            <h3 class="vstock-slide-title" *ngIf="currentVstockSlide; else loadingTitle">{{ currentVstockSlide.title }}
            </h3>
            <ng-template #loadingTitle>
              <h3 class="vstock-slide-title">Loading...</h3>
            </ng-template>
            <p *ngIf="currentVstockSlide; else loadingDesc">{{ currentVstockSlide.description }}</p>
            <ng-template #loadingDesc>
              <p>Loading content...</p>
            </ng-template>
            <a [routerLink]="'/dashboard/v-stock-ver2'" [queryParams]="{ uid: currentUser?.id }" class="vstock-btn"
              *ngIf="currentVstockSlide; else loadingBtn">
              {{ currentVstockSlide.button }}
            </a>
            <ng-template #loadingBtn>
              <a [routerLink]="'/dashboard/v-stock-ver2'" [queryParams]="{ uid: currentUser?.id }" class="vstock-btn">
                Loading...
              </a>
            </ng-template>
            <div class="pagination-dots">
              <button type="button" class="dot" *ngFor="let slide of vstockSlides; let i = index"
                [class.active]="i === currentVstockSlideIndex" (click)="goToVstockSlide(i)"
                [attr.aria-label]="'Go to slide ' + (i + 1)"
                [attr.aria-current]="i === currentVstockSlideIndex ? 'true' : null"></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-4">
      <div class="dashboard-card connect-card">
        <div class="connect-card-content">
          <div class="connect-card-text">
            <h3>{{ translate.currentLang === 'en' ? 'Connect with CAL Bangladesh' : 'CAL বাংলাদেশের সাথে সংযুক্ত হন' }}
            </h3>
            <p class="subtitle">{{ translate.currentLang === 'en' ? 'Follow us for market insights, updates, and events'
              :
              'বাজার অন্তর্দৃষ্টি, আপডেট এবং ইভেন্টের জন্য আমাদের অনুসরণ করুন' }}</p>
          </div>
          <div class="social-icons">
            <a href="https://www.youtube.com/@CALBangladesh" target="_blank" rel="noopener noreferrer"
              class="social-icon youtube" aria-label="CAL Bangladesh on YouTube">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
              </svg>
            </a>
            <a href="https://www.facebook.com/CALBangladesh" target="_blank" rel="noopener noreferrer"
              class="social-icon facebook" aria-label="CAL Bangladesh on Facebook">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
              </svg>
            </a>
            <a href="https://www.linkedin.com/company/cal-bangladesh/about/" target="_blank" rel="noopener noreferrer"
              class="social-icon linkedin" aria-label="CAL Bangladesh on LinkedIn">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Application status (as a label) plus a real link for the next action -->
<ng-template #statusTemplate let-status="status" let-prdType="prdType" let-link="link">
  <div class="product-status" *ngIf="status">
    <div class="product-status-row">
      <span class="product-status-label">{{ translate.currentLang === 'en' ? 'Application' : 'আবেদন' }}</span>
      <span class="status-pill" [ngClass]="getStatusClass(status)">{{ getStatusText(status) }}</span>
    </div>
    <app-approval-progress *ngIf="status === 'Approval Pending'" [prdType]="prdType"></app-approval-progress>
  </div>
  <a class="view-portfolio-btn" [routerLink]="link">{{ getStatusActionText(status) }}</a>
</ng-template>